import { render, staticRenderFns } from "./SelfCourseStat.vue?vue&type=template&id=1540f0d9&scoped=true&"
import script from "./SelfCourseStat.vue?vue&type=script&lang=js&"
export * from "./SelfCourseStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540f0d9",
  null
  
)

export default component.exports